import type { AutocompleteValue, TextFieldProps } from '@mui/material';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { AutocompleteProps } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAdPagesOptions } from '../api/getAdPages';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

interface PageNameAutocompleteProps extends Omit<
  AutocompleteProps<number, true, boolean, false>,
  'value' | 'onChange' | 'options' | 'renderInput'
> {
  value?: AutocompleteValue<number, true, false, false>;
  onChange: (value: AutocompleteValue<number, true, false, false>) => void;
  InputProps?: TextFieldProps;
  allowedValues: string[];
}

const PageNameAutocomplete = ({ InputProps, value, onChange, allowedValues, ...props }: PageNameAutocompleteProps) => {
  const { network, region } = useFacebookAdsLibraryParams();
  const { data } = useSuspenseQuery({
    ...getAdPagesOptions({ network, region }),
    select: (data) =>
      data.map(({ id, name }) => ({ label: name, value: id })).filter(({ value }) => allowedValues.includes(value)),
  });

  return (
    <CheckboxAutocomplete
      {...props}
      value={value}
      onChange={onChange as (value: OptionValue[]) => void}
      InputProps={InputProps}
      id="pageName-autocomplete"
      options={data}
    />
  );
};

export default PageNameAutocomplete;
